import "../assets/useImageStyles.css";
import { openBlock as b, createElementBlock as x, createElementVNode as _, defineComponent as k, ref as n, watchEffect as M, createBlock as w, unref as L, createCommentVNode as I, computed as d } from "vue";
import { l as P } from "./useStore.CNSXUGVb.js";
import { g as A } from "./Text.vue_vue_type_style_index_0_lang.B5gHH0dB.js";
import { D as h } from "./maps.BMuTsKez.js";
function W(l, e) {
  return b(), x("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    _("path", { d: "M13.5 9C12.122 9 11 7.878 11 6.5S12.122 4 13.5 4 16 5.122 16 6.5 14.878 9 13.5 9zm0-4c-.827 0-1.5.673-1.5 1.5S12.673 8 13.5 8 15 7.327 15 6.5 14.327 5 13.5 5z" }),
    _("path", { d: "M18.5 0h-17C.673 0 0 .673 0 1.5v17c0 .827.673 1.5 1.5 1.5h17c.827 0 1.5-.673 1.5-1.5v-17c0-.827-.673-1.5-1.5-1.5zM1 18.5v-4.807l4.197-4.617c.085-.093.196-.145.314-.147s.231.048.318.139l9.5 9.932H1.499a.5.5 0 01-.5-.5zm18 0a.5.5 0 01-.5.5h-1.786L6.553 8.377a1.42 1.42 0 00-2.095.027l-3.457 3.803V1.5a.5.5 0 01.5-.5h17a.5.5 0 01.5.5v17z" })
  ]);
}
const U = ["data-module-id", "data-no-image"], C = ["data-image-loaded", "src", "alt"], E = /* @__PURE__ */ k({
  __name: "ImageWithBehaviour",
  props: {
    moduleProps: {},
    maxWidth: {},
    maxHeight: {}
  },
  setup(l) {
    const e = l, a = n(), m = n(), u = n(), v = n(e.maxWidth), g = n(e.maxHeight), c = n(!1), s = n(!1), t = n(1), o = P();
    function p() {
      if (a.value) {
        const {
          naturalWidth: i,
          naturalHeight: r
        } = a.value;
        t.value = i / r, c.value = !0;
      }
    }
    function f(i) {
      c.value = !1, s.value = !0;
      const r = new Image();
      r.onload = () => {
        m.value = i, r.remove();
      }, r.onerror = () => {
        m.value = null, r.remove();
      }, r.src = i;
    }
    M(() => {
      if (e.moduleProps.image) {
        const i = o == null ? void 0 : o.literals.getLocaleImageUrl(e.moduleProps.image);
        i && i !== m.value && f(i), u.value = o == null ? void 0 : o.literals.getLocaleImageUrl(e.moduleProps.image);
      }
    }), M(() => {
      const i = e.moduleProps.maxWidth ? Math.min(e.moduleProps.maxWidth, e.maxWidth) : e.maxWidth;
      g.value = Math.min(e.maxHeight, i / t.value), v.value = g.value * t.value;
    });
    function $() {
      const i = A(e.moduleProps.behaviour.type);
      o == null || o.handlers.callHandler(i, e.moduleProps.id);
    }
    return (i, r) => (b(), x("div", {
      class: "thn--tool-image-with-behaviour",
      "data-module-id": e.moduleProps.id,
      "data-no-image": !m.value && !s.value,
      onClick: $
    }, [
      !m.value && !s.value ? (b(), w(L(W), {
        key: 0,
        class: "thn--tool-image-with-behaviour__icon"
      })) : I("", !0),
      m.value ? (b(), x("img", {
        key: 1,
        class: "thn--tool-image-with-behaviour__image",
        ref_key: "imageDom",
        ref: a,
        "data-image-loaded": c.value,
        src: m.value,
        alt: u.value,
        onLoad: p
      }, null, 40, C)) : I("", !0)
    ], 8, U));
  }
});
function V(l, e) {
  const a = P(), m = d(() => {
    var t;
    return (t = l.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageUrl(l.value.image) : "";
  }), u = d(() => {
    var t;
    return (t = l.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageUrl(l.value.imageMobile) : "";
  }), v = d(() => {
    var t;
    return (t = l.value) != null && t.image ? a == null ? void 0 : a.literals.getLocaleImageAlt(l.value.image) : "";
  }), g = d(() => {
    var t;
    return (t = l.value) != null && t.imageMobile ? a == null ? void 0 : a.literals.getLocaleImageAlt(l.value.imageMobile) : "";
  }), c = d(() => e.value === h.Mobile && u.value ? u.value : m.value), s = d(() => e.value === h.Mobile && g.value ? g.value : v.value);
  return {
    imageUrl: c,
    imageAlt: s
  };
}
const N = (l, e, a = n("left")) => ({
  imageStyles: d(() => {
    var p, f;
    if (e.value === h.Desktop && !((p = l.value) != null && p.imagePadding) || e.value === h.Mobile && !((f = l.value) != null && f.imageMobilePadding))
      return "";
    const u = e.value === h.Mobile ? l.value.imageMobilePadding : l.value.imagePadding;
    if (!u)
      return "";
    const {
      top: v,
      bottom: g,
      left: c,
      right: s,
      format: t
    } = u, o = {
      top: `${v}${t}`,
      bottom: a.value !== "top" ? `${g}${t}` : "0px",
      right: a.value !== "left" ? `${s}${t}` : "0px",
      left: a.value !== "right" ? `${c}${t}` : "0px"
    };
    return `
      padding: ${o.top} ${o.right} ${o.bottom} ${o.left};
    `;
  })
});
export {
  E as _,
  N as a,
  W as r,
  V as u
};
//# sourceMappingURL=useImageStyles.CHL0VDP2.js.map
